import { fnv1aHex } from '@sketch/utils'

/**
 * Create a unique identifier for layers, even for those inside symbol instances.
 * The layer path hash is basically a hash representing the path of the layer in the tree.
 * (Computed based on its parent's layer path hash and its own UUID.
 * For root elements, this is just the hash of the element's UUID.)
 */
export function computeLayerPathHash(
  layerUUID: string,
  parentLayerPathHash?: string
): string {
  const path = parentLayerPathHash
    ? `${parentLayerPathHash}${layerUUID}`
    : layerUUID
  return fnv1aHex(path)
}
